import { Button, Pagination, TableEmptyState } from '@practium/ui';
import type { BillingPaymentRow } from '../types/billing.types';
import styles from './BillingContractedPlansCard.module.css';
import { BillingTable } from './BillingTable';
import { BillingTableSkeleton } from './BillingTableSkeleton';

interface BillingContractedPlansCardProps {
	rows: BillingPaymentRow[] | undefined;
	subtitle: string;
	page: number;
	totalPages: number;
	onPageChange: (page: number) => void;
	onViewReport: () => void;
	isLoading?: boolean;
	isError?: boolean;
}

export const BillingContractedPlansCard = ({
	rows,
	subtitle,
	page,
	totalPages,
	onPageChange,
	onViewReport,
	isLoading,
	isError,
}: BillingContractedPlansCardProps) => {
	const isEmpty = !isLoading && !isError && rows?.length === 0;

	return (
		<div className={styles.card}>
			<div className={styles.header}>
				<div className={styles.headerLeft}>
					<h2 className={styles.title}>Planos Contratados</h2>
					<span className={styles.subtitle}>{subtitle}</span>
				</div>
				<Button variant="secondary" onClick={onViewReport} className={styles.button}>
					Ver Relatório
				</Button>
			</div>

			{isLoading ? (
				<BillingTableSkeleton />
			) : isEmpty ? (
				<TableEmptyState
					title="Nenhum pagamento encontrado"
					subtitle="Não há pagamentos para o período selecionado."
				/>
			) : (
				!isError && <BillingTable rows={rows} />
			)}

			{!isLoading && !isError && !isEmpty && totalPages > 1 && (
				<div className={styles.footer}>
					<Pagination page={page} totalPages={totalPages} onPageChange={onPageChange} />
				</div>
			)}
		</div>
	);
};
